import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom'
import ObjectLogs from '../../misc/ObjectLogs';
import { GetObjectLogs } from '../../../store/ObjectLogAction';
import { CoreObjectLogs } from '../../../models/CoreObjectLogs';
import * as LogTypes from '../../../util/FlowSyncLoggerTypes';
import { useTranslation } from 'react-i18next';
import { RequestState } from '../../../models/RequestState';
import { RootState } from '../../../store/store';


const ClassroomViewObjectLogs = () => {
    const { t } = useTranslation('classroomAdmin');

    const { classroomId } = useParams();
    const dispatch = useDispatch();
    const objectLogs = useSelector<RootState, RequestState<CoreObjectLogs[]>>(state => state.objectLog.objectLogs);

    useEffect(() => {
        if (classroomId) {
            GetObjectLogs({ objectId: classroomId, objectSource: LogTypes.Flowsync.SourceName, objectType: LogTypes.Flowsync.ClassroomAdminClassroom })(dispatch);
        }
    }, [dispatch, classroomId]);

    return (<>
        <ObjectLogs
            objectLogs={objectLogs}
            noResMsg={t('classroomAdmin.objectLogs.noResult', { ns: 'classroomAdmin' })}
        />
    </>);
}

export default ClassroomViewObjectLogs;
